"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-thirteen/sections/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSection2344sItem = {
    key: Key | null | undefined;
    /** Detected variants: "footer-widget mt-0" | "footer-widget" */
    className: string;
    /** Detected variants: "About Us" | "Top Categories" | "Best Sellers" | "Support" | "Policies" | "Others" */
    h40Text: ReactNode;
    /** Detected variants: "col-xl-2 col-lg-3 col-md-4 col-sm-4" */
    divClassName?: string;
    /** Detected variants: "footer-title" */
    h40ClassName?: string;
    footerMenuItems?: FooterSectionUlsItem[];
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Home" | "About" | "Shop" | "Order Tracking" | "Offers" | "Pain Relief" | "Antibiotics" | "IUI Procedures" | "Heart Care" | "Genetic Testing" | "Supplements" | "Baby Care" | "Ayurveda" | "Surgical & Devices" | "BP Medicines" | "Contact Us" | "Returns" | "Prescription Upload" | "My Account" | "Customer Support" | "Terms" | "Privacy" | "Shipping" | "Payment" | "Refund" | "Download App" | "Order Status" | "Contact Support" | "WhatsApp Chat" | "Pharmacy Locator" */
    link0Text: ReactNode;
    /** Detected variants: "#" | "all_routes.contactUs" */
    href: string;
};

type FooterSection1sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/pay-1.svg" | "/Templates/Doccure/img/icons/pay-2.svg" | "/Templates/Doccure/img/icons/pay-3.svg" | "/Templates/Doccure/img/icons/pay-4.svg" */
    src: string;
    /** Detected variants: "pay" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    className?: string;
};

type FooterSectionUls7Item = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeThirteenFooterSectionGeneratedProps = {
    divDiv0H40H4Props?: Partial<ComponentProps<"h4">> | ((item: FooterSection2344sItem) => Partial<ComponentProps<"h4">>);
    footerDiv0Div0Div0ClassName?: string;
    /** Default: "PHARMACY" */
    footerDiv0Div1DivText?: ReactNode;
    /** Default: "footer" */
    footerDiv0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/footer-thirteen-img.svg" */
    footerDiv0ImageWithBasePath0ImageSrc?: string;
    footerDiv0ImageWithBasePath0ImageVisible?: boolean;
    footerDiv0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    footerDiv1Div0Div0ClassName?: string;
    /** Default: "© 2025 Doccure — Your Health, Our Priority." */
    footerDiv1Div0Div0Div0P0PText?: ReactNode;
    imageWithBasePathImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: FooterSection1sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    footerSectionUls7LiLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls7Item) => Partial<ComponentProps<typeof SmartLink>>);
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSection2344s: FooterSection2344sItem[];
    footerSection1s: FooterSection1sItem[];
    footerSectionUls7: FooterSectionUls7Item[];
    footerSection2344sItemWrapper?: (item: FooterSection2344sItem, content: ReactNode) => ReactNode;
    footerSection2344sRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection2344sH4Visible?: boolean;
    footerSection2344sH4Renderer?: (item: FooterSection2344sItem, defaultNode: ReactNode) => ReactNode;
    footerSection2344sH4Props?: Partial<ComponentProps<"h4">> | ((item: FooterSection2344sItem) => Partial<ComponentProps<"h4">>);
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkVisible?: boolean;
    footerSectionUlsLinkRenderer?: (item: FooterSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSection1sItemWrapper?: (item: FooterSection1sItem, content: ReactNode) => ReactNode;
    footerSection1sRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection1sImageVisible?: boolean;
    footerSection1sImageRenderer?: (item: FooterSection1sItem, defaultNode: ReactNode) => ReactNode;
    footerSection1sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: FooterSection1sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    footerSectionUls7ItemWrapper?: (item: FooterSectionUls7Item, content: ReactNode) => ReactNode;
    footerSectionUls7Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls7LinkVisible?: boolean;
    footerSectionUls7LinkRenderer?: (item: FooterSectionUls7Item, defaultNode: ReactNode) => ReactNode;
    footerSectionUls7LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls7Item) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeThirteenFooterSectionGenerated: FC<HomeThirteenFooterSectionGeneratedProps> = ({
    footerDiv0Div1DivText = "PHARMACY",
    footerDiv0ImageWithBasePath0ImageAlt = "footer",
    footerDiv0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/footer-thirteen-img.svg",
    footerDiv0ImageWithBasePath0ImageVisible,
    footerDiv0ImageWithBasePath0ImageRenderer,
    footerDiv0ImageWithBasePath0ImageProps,
    footerDiv1Div0Div0Div0P0PText = "© 2025 Doccure — Your Health, Our Priority.",
    divDiv0H40H4Props,
    footerSectionUls7LiLink0LinkProps,
    liLink0LinkProps,
    imageWithBasePathImageProps,
    footerDiv0Div0Div0ClassName,
    footerDiv1Div0Div0ClassName,
    footerSection2344s,
    footerSection1s,
    footerSectionUls7,
    footerSection2344sItemWrapper,
    footerSection2344sRenderer,
    footerSection2344sH4Visible,
    footerSection2344sH4Renderer,
    footerSection2344sH4Props,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUlsLinkVisible,
    footerSectionUlsLinkRenderer,
    footerSectionUlsLinkProps,
    footerSection1sItemWrapper,
    footerSection1sRenderer,
    footerSection1sImageVisible,
    footerSection1sImageRenderer,
    footerSection1sImageProps,
    footerSectionUls7ItemWrapper,
    footerSectionUls7Renderer,
    footerSectionUls7LinkVisible,
    footerSectionUls7LinkRenderer,
    footerSectionUls7LinkProps,
}) => {
    return (
        <footer className="footer footer-thirteen">
            <div className="footer-top">
                <div className="container">
                    <div className={footerDiv0Div0Div0ClassName ?? "row g-sm-5 g-4"}>
                        {renderCollectionNode(
                            footerSection2344s,
                            (item: FooterSection2344sItem) => (
                                <div className={item.divClassName ?? "col-xl-2 col-lg-3 col-md-4 col-sm-4"} key={item.key}>
                                    <div className={item.className}>
                                        {renderItemNode(footerSection2344sH4Visible, footerSection2344sH4Renderer, item, (
                                            <h4 className={item.h40ClassName ?? "footer-title"} {...(typeof footerSection2344sH4Props === "function" ? footerSection2344sH4Props(item) : (footerSection2344sH4Props ?? {}))} {...(typeof divDiv0H40H4Props === "function" ? divDiv0H40H4Props(item) : (divDiv0H40H4Props ?? {}))}>{item.h40Text}</h4>
                                        ))}
                                        <ul className="footer-menu">
                                            {renderCollectionNode(
                                                item.footerMenuItems ?? [],
                                                (item: FooterSectionUlsItem) => (
                                                    <li key={item.key}>
                                                        {renderItemNode(footerSectionUlsLinkVisible, footerSectionUlsLinkRenderer, item, (
                                                            <SmartLink href={item.href} {...(typeof footerSectionUlsLinkProps === "function" ? footerSectionUlsLinkProps(item) : (footerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                        ))}
                                                    </li>
                                                ),
                                                footerSectionUlsItemWrapper,
                                                footerSectionUlsRenderer
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            ),
                            footerSection2344sItemWrapper,
                            footerSection2344sRenderer
                        )}
                    </div>
                </div>
                {renderNode(footerDiv0ImageWithBasePath0ImageVisible, footerDiv0ImageWithBasePath0ImageRenderer, (
                    <SmartImage src={footerDiv0ImageWithBasePath0ImageSrc} alt={footerDiv0ImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(footerDiv0ImageWithBasePath0ImageProps ?? {})} />
                ))}
                <div className="animated-text">{footerDiv0Div1DivText}</div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className={footerDiv1Div0Div0ClassName ?? "row g-4 align-items-center"}>
                        <div className="col-xl-4 col-lg-12 col-md-12">
                            <p>{footerDiv1Div0Div0Div0P0PText}</p>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                            <div className="pay-img">
                                {renderCollectionNode(
                                    footerSection1s,
                                    (item: FooterSection1sItem) => (
                                        renderItemNode(footerSection1sImageVisible, footerSection1sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "pay"} className={item.className ?? "img-fluid img-1"} {...(typeof footerSection1sImageProps === "function" ? footerSection1sImageProps(item) : (footerSection1sImageProps ?? {}))} {...(typeof imageWithBasePathImageProps === "function" ? imageWithBasePathImageProps(item) : (imageWithBasePathImageProps ?? {}))} key={item.key} />
                                        ))
                                    ),
                                    footerSection1sItemWrapper,
                                    footerSection1sRenderer
                                )}
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                            <ul className="social-icon">
                                {renderCollectionNode(
                                    footerSectionUls7,
                                    (item: FooterSectionUls7Item) => (
                                        <li key={item.key}>
                                            {renderItemNode(footerSectionUls7LinkVisible, footerSectionUls7LinkRenderer, item, (
                                                <SmartLink href={item.href ?? "#"} {...(typeof footerSectionUls7LinkProps === "function" ? footerSectionUls7LinkProps(item) : (footerSectionUls7LinkProps ?? {}))} {...(typeof footerSectionUls7LiLink0LinkProps === "function" ? footerSectionUls7LiLink0LinkProps(item) : (footerSectionUls7LiLink0LinkProps ?? {}))}>
                                                    <i className={item.className} />
                                                </SmartLink>
                                            ))}
                                        </li>
                                    ),
                                    footerSectionUls7ItemWrapper,
                                    footerSectionUls7Renderer
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default HomeThirteenFooterSectionGenerated;
